<template>
    <div class="w-full px-12 mt-48 xs:w-1/2 sm:w-1/3">
        <!--    CARD START-->
        <div>
            <div class="flex items-center justify-center h-full p-20 border-2 border-white border-dashed rounded-md py-96">
                <div>
                    <div class="flex items-center justify-center">
                        <div class="flex items-center justify-center flex-shrink-0 w-48 h-48 bg-yellow-200 rounded-full">
                            <div class="flex-shrink-0 block w-24 h-24 fill-current text-primary">
                                <IconPersonSVG class="w-24 h-24" />
                            </div>
                        </div>
                    </div>

                    <button
                        @click="openModal('add_travel_manager')"
                        class="mt-16 block font-normal text-center underline title-lg text-primary hover:text-blue-300 transition.all duration-200 ease-in-out"
                    >
                        {{ $t('info.add_tm') }}
                    </button>
                </div>
            </div>
        </div>
        <!--    CARD END-->

        <!--    MODAL START-->
        <div class="micromodal" id="add_travel_manager" aria-hidden="true">
            <div class="px-10 micromodal__overlay" tabindex="-1">
                <div class="micromodal__container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
                    <header class="micromodal__header">
                        <h2 class="pb-24 pr-48 title-2xl text-primary">{{ $t('info.add_tm') }}</h2>

                        <button class="micromodal__close" aria-label="Close modal" data-micromodal-close>
                            <span class="flex-shrink-0 block w-20 h-20 text-black pointer-events-none fill-current">
                                <IconXSVG />
                            </span>
                        </button>
                    </header>
                    <div class="micromodal__content">
                        <div class="flex self-form-wrap">
                            <div class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="eesnimi">{{ $t('signup.fname') }}</label>
                                <div class="relative">
                                    <input type="text" id="eesnimi" placeholder="" name="eesnimi" value="" class="e5-input" />
                                </div>
                            </div>

                            <div class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="perenimi">{{ $t('signup.lname') }}</label>
                                <div class="relative">
                                    <input type="text" id="perenimi" placeholder="" name="perenimi" value="" class="e5-input" />
                                </div>
                            </div>

                            <div class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="isikukood">{{ $t('info.identity_code') }}</label>
                                <div class="relative">
                                    <input type="text" id="isikukood" placeholder="" name="isikukood" value="" class="e5-input" />
                                </div>
                            </div>
                            <Dob :label="$t('info.dob')" is-dob :uniqueId="'add-travel-manager-dob'" />
                            <div :class="['w-full self-form-wrap-item', { 'e5-error': !isEmailFormatCorrect }]">
                                <label class="e5-form-label" for="epost">{{ $t('footer.email') }}</label>
                                <div class="relative">
                                    <input type="email" id="epost" placeholder="" name="epost" v-model="email" class="e5-input" />
                                </div>
                            </div>

                            <div class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="telefon">{{ $t('info.phone') }}</label>
                                <div class="relative">
                                    <input
                                        type="tel"
                                        id="telefon"
                                        placeholder=""
                                        name="telefon"
                                        v-model="phone"
                                        @input="sanitizePhoneInput"
                                        class="e5-input"
                                    />
                                </div>
                            </div>

                            <div class="flex items-center justify-between px-8 pt-16 w-full">
                                <div>
                                    <button class="self-btn-primary" :disabled="!isEmailFormatCorrect">
                                        {{ $t('info.save') }}

                                        <span class="text-yellow-300 self-btn-primary__icon">
                                            <IconArrowAltSVG />
                                        </span>
                                    </button>
                                </div>

                                <div>
                                    <button data-micromodal-close="" class="self-btn-plain">
                                        <span class="w-16 ml-0 mr-4 self-btn-plain__icon">
                                            <IconXSVG />
                                        </span>
                                        <span class="self-btn-plain__text">{{ $t('info.cancel') }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--    MODAL END-->
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import IconPersonSVG from '@/assets/static/icons-src/icon-person.svg';
import IconXSVG from '@/assets/static/icons-src/icon-x.svg';
import IconArrowAltSVG from '@/assets/static/icons-src/icon-arrow-alt.svg';
import Dob from '@/components/info-view-components/Dob.vue';
import UtilsMixin from '@/scripts/utils';
import validator from 'validator';

@Component({
    components: {
        IconPersonSVG,
        IconXSVG,
        IconArrowAltSVG,
        Dob
    },
    mixins: [UtilsMixin]
})
export default class AddTravelManager extends Vue {
    email = '';
    phone = '';

    get isEmailFormatCorrect(): boolean {
        if (!this.email?.length) return true; // Empty email is valid (not required to be filled)
        return validator.isEmail(this.email.trim());
    }

    sanitizePhoneInput() {
        this.phone = this.phone.replace(/[^0-9+]/g, '');
    }
}
</script>

<style scoped></style>
